"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OCSReportEntryStatus = exports.OCSReportEntryType = void 0;
var OCSReportEntryType;
(function (OCSReportEntryType) {
    OCSReportEntryType["RETAILER"] = "retailer";
    OCSReportEntryType["SUBMISSION_EVENT"] = "submission_event";
    OCSReportEntryType["SUBMISSION_POSITION"] = "submission_position";
    OCSReportEntryType["SUBMISSION_EVENT_ATTEMPT"] = "submission_event_attempt";
    OCSReportEntryType["SUBMISSION_POSITION_ATTEMPT"] = "submission_position_attempt";
    OCSReportEntryType["PROCESS_ON_DATE"] = "process_on_date";
    OCSReportEntryType["RESYNC_PRODUCT"] = "resync_product";
})(OCSReportEntryType || (exports.OCSReportEntryType = OCSReportEntryType = {}));
var OCSReportEntryStatus;
(function (OCSReportEntryStatus) {
    OCSReportEntryStatus["PREPARING"] = "preparing";
    OCSReportEntryStatus["SUBMITTING"] = "submitting";
    OCSReportEntryStatus["SUCCESSFUL"] = "successful";
    OCSReportEntryStatus["FAILED"] = "failed";
})(OCSReportEntryStatus || (exports.OCSReportEntryStatus = OCSReportEntryStatus = {}));
//# sourceMappingURL=enums.js.map